// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/actions";
import {
	getSelectRow,
	getHandlerTableChange,
	NoRecordsFoundMessage,
	PleaseWaitMessage,
	sortCaret,
	headerSortingClasses,
} from "../../../_metronic/_helpers";
import * as uiHelpers from "./uiHelpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../_metronic/_partials/controls";
import { useUIContext } from "./uiContext";
import { PATH } from "./page";
import Icon from '@material-ui/core/Icon';

import { useIntl } from "react-intl";

export function Table() {
	const intl = useIntl();
	const UIContext = useUIContext();
	const UIProps = useMemo(() => {
		return {
			ids: UIContext.ids,
			setIds: UIContext.setIds,
			queryParams: UIContext.queryParams,
			setQueryParams: UIContext.setQueryParams,
			editItem: UIContext.editItem,
			deleteItem: UIContext.deleteItem,
		};
	}, [UIContext]);

	// Getting curret state of customers list from store (Redux)
	const { currentState } = useSelector(
		(state) => ({ currentState: state.customer }),
		shallowEqual
	);
	const { totalCount, entities, listLoading } = currentState;

	// Customers Redux state
	const dispatch = useDispatch();
	useEffect(() => {
		// clear selections list
		UIProps.setIds([]);
		// server call by queryParams
		dispatch(actions.fetchItems(UIProps.queryParams));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [UIProps.queryParams, dispatch]);
	// Table columns
	const columns = [
		{
			dataField: "id",
			text: intl.formatMessage({ id: "Table.OrderId" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "created_at",
			text: intl.formatMessage({ id: "Table.Date" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "customer",
			text: intl.formatMessage({ id: "Table.Customer" }),
			sort: true,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "promotion",
			text: intl.formatMessage({ id: "Table.Promotion" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "quantity",
			text: intl.formatMessage({ id: "Table.Quantity" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "delivery_method",
			text: intl.formatMessage({ id: "Table.Delivery" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "price",
			text: intl.formatMessage({ id: "Table.Price" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "delivery_fee",
			text: intl.formatMessage({ id: "Table.DeliveryFee" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "total",
			text: intl.formatMessage({ id: "Table.Total" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "staff",
			text: intl.formatMessage({ id: "Table.Staff" }),
			sort: false,
			sortCaret: sortCaret,
			headerSortingClasses,
		},
		{
			dataField: "status",
			text: intl.formatMessage({ id: "Table.Status" }),
			sort: false,
			sortCaret: sortCaret,
			formatter: columnFormatters.StatusColumnFormatter,
			formatExtraData: {
				intl: intl
			},
			headerSortingClasses,
		},
		{
			dataField: "action",
			text: "",
			formatter: columnFormatters.ActionsColumnFormatter,
			formatExtraData: {
				intl: intl,
				editItem: UIProps.editItem
			},
			classes: "text-right pr-0",
			headerClasses: "text-right pr-3"
		},
	];
	// Table pagination properties
	const paginationOptions = {
		custom: true,
		totalSize: totalCount,
		sizePerPageList: uiHelpers.sizePerPageList,
		sizePerPage: UIProps.queryParams.pageSize,
		page: UIProps.queryParams.pageNumber,
	};
	return (
		<>
			<PaginationProvider pagination={paginationFactory(paginationOptions)}>
				{({ paginationProps, paginationTableProps }) => {
					return (
						<Pagination
							isLoading={listLoading}
							paginationProps={paginationProps}
						>
							<BootstrapTable
								wrapperClasses="table-responsive"
								bordered={false}
								classes="table table-head-custom table-vertical-center overflow-hidden"
								bootstrap4
								remote
								keyField="_id"
								data={entities === null ? [] : entities}
								columns={columns}
								defaultSorted={uiHelpers.defaultSorted}
								onTableChange={getHandlerTableChange(
									UIProps.setQueryParams
								)}
								selectRow={getSelectRow({
									entities,
									ids: UIProps.ids,
									setIds: UIProps.setIds,
								})}
								{...paginationTableProps}
							>
								<PleaseWaitMessage entities={entities} />
								<NoRecordsFoundMessage entities={entities} />
							</BootstrapTable>
						</Pagination>
					);
				}}
			</PaginationProvider>
		</>
	);
}
